import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AlertController, ModalController } from "@ionic/angular";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { FairAppIdRequest } from "../../../api/models/fair-app-id-request";
import { KalkulationGutachtenPosition } from "../../../api/models/kalkulation-gutachten-position";
import { GutachtenService } from "../../../api/services/gutachten.service";
import { odataGutachtenPositionPropertyLabels } from "../../../kalkulation/kalkulation.page";
import { getLowerCaseInputValue, getStringFilterConditionForDatatable } from "../../global-functions/global-functions";
import { LoveItToastService } from "../../services/love-it-toast.service";

@Component({
  selector: "app-kalkulation-favoriten-list",
  templateUrl: "./kalkulation-favoriten-list.component.html",
  styleUrls: ["./kalkulation-favoriten-list.component.scss"],
  standalone: false,
})
export class KalkulationFavoritenListComponent implements OnInit, AfterViewInit {
  isSaving: boolean = false;
  loadingData: boolean = false;
  loadedData: KalkulationGutachtenPosition[] = [];

  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ["Positionsgrupper", "Bezeichnung", "actions"];
  dataSourceMatTable: MatTableDataSource<any>;
  filterFormGroupForDatatable: FormGroup;

  constructor(
    private modalController: ModalController,
    private oidcSecurityService: OidcSecurityService,
    private gutachtenService: GutachtenService,
    private alertController: AlertController,
    private loveItToastService: LoveItToastService,
    private fb: FormBuilder,
  ) {
    this.dataSourceMatTable = new MatTableDataSource([]);
  }

  ngOnInit() {
    this.updateList();

    this.filterFormGroupForDatatable = this.fb.group({
      Positionsgrupper: [""],
      Bezeichnung: [""],
    });

    this.filterFormGroupForDatatable.valueChanges.subscribe(() => {
      this.dataSourceMatTable.data = this.getFilteredDataForDatatable(this.loadedData);
    });
  }

  ngAfterViewInit() {
    this.dataSourceMatTable.sort = this.sort;
  }

  getFilteredDataForDatatable(positionen: KalkulationGutachtenPosition[]) {
    const positionsgrupper = getLowerCaseInputValue(this.filterFormGroupForDatatable.get("Positionsgrupper").value);

    const bezeichnung = getLowerCaseInputValue(this.filterFormGroupForDatatable.get("Bezeichnung").value);

    return positionen.filter(
      (position) =>
        getStringFilterConditionForDatatable(position.GutachtenPosition.Positionsgrupper, positionsgrupper) &&
        getStringFilterConditionForDatatable(position.GutachtenPosition.Bezeichnung, bezeichnung),
    );
  }

  updateList() {
    this.loadingData = true;
    this.dataSourceMatTable.data = [];
    this.gutachtenService
      .gutachtenPositionListCreate({
        token: this.oidcSecurityService.getToken(),
      })
      .subscribe({
        next: (response: KalkulationGutachtenPosition[]) => {
          this.loadedData = response.map((entry) => entry);
          this.dataSourceMatTable.data = this.getFilteredDataForDatatable(this.loadedData);
          this.loadingData = false;
        },
        error: (err) => {
          this.loadingData = false;
        },
      });
  }

  removeSavedFavouritePosition(entry: KalkulationGutachtenPosition) {
    this.isSaving = true;
    this.gutachtenService
      .gutachtenPositionDeleteCreate({
        token: this.oidcSecurityService.getToken(),
        id: entry.id,
      } as FairAppIdRequest)
      .subscribe({
        next: (response) => {
          this.isSaving = false;
          this.loadedData = this.loadedData.filter((loadedPosition) => loadedPosition.id != entry.id);
          this.dataSourceMatTable.data = this.getFilteredDataForDatatable(this.loadedData);
          this.loveItToastService.showToastMessage("Favorit gelöscht.");
        },
        error: async (error) => {
          this.isSaving = false;
        },
      });
  }

  async deleteFavoritDialogAnzeigen(entry: KalkulationGutachtenPosition) {
    const alert = await this.alertController.create({
      header: "Favoriten löschen?",
      message: "Der Favorit ist nach dem Löschen nicht mehr verfügbar.",
      buttons: [
        {
          cssClass: "color-primary",
          text: "Abbrechen",
          role: "cancel",
        },
        {
          cssClass: "color-danger",
          text: "Löschen",
          handler: () => {
            this.removeSavedFavouritePosition(entry);
          },
        },
      ],
    });

    await alert.present();
  }

  cancelButton() {
    this.modalController.dismiss(null, "cancel");
  }

  onDatatableActivate(event: any, position: KalkulationGutachtenPosition) {
    if (event.target.id === "delete-button") {
      return;
    }

    this.modalController.dismiss(position.GutachtenPosition, "confirm");
  }

  protected readonly odataGutachtenPositionPropertyLabels = odataGutachtenPositionPropertyLabels;
}
